import React from 'react';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import ProductDocumentContent from '../components/ProductDocumentContent/ProductDocumentContent';
import './Products.css';

const ProductsDocuments = () => {
  return (
    <div className="products-page">
      <ProductsHero title="Documents" bannerSection="Products > Document">
        <p className='text-muted'>
          flowdo Documents provides you the ability to manage all your documents organized in one place,
          with additional facility to set reminders based on expiry/renewal date. Collaborate with team
          members for updating documents and tracking version history. Share within your organization or
          with external members with one click.
        </p>
        <p className='text-muted'>
          flowdo Documents is Dropbox with additional features, giving you the ability to have unlimited
          storage space and unlimited users. You no longer need to set reminders or separate excel sheets to
          track document details and their validity. flowdo frees you from the hassle of reminders and tracking,
          by even allowing you to create tasks based on document renewals.
        </p>
      </ProductsHero>
      <ProductDocumentContent />
    </div>
  );
};

export default ProductsDocuments;
